<template>
    <app-admin-layout>
        <Head>
            <title>Suchergebnis</title>
        </Head>

        <div class="portal-search">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <card>
                            <card-header>
                                <card-overline>Suchergebnis</card-overline>
                                <card-title>Vorgänge</card-title>
                            </card-header>
                            <card-content>
                                <table class="table table--stripped table--card">
                                    <thead>
                                    <tr>
                                        <th>
                                            PF-Nr
                                        </th>
                                        <th>
                                            Kunde
                                        </th>
                                        <th class="text-right">
                                            Stückzahl
                                        </th>
                                        <th class="text-right">
                                            Liefertermin
                                        </th>
                                        <th class="text-center">
                                            Zeichnung
                                            <span><span>PDF | 3D</span></span>
                                        </th>
                                        <th class="text-right">
                                            Anfragedatum
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="askForQuote in askForQuotes" :key="askForQuote.index">
                                        <td>
                                            <Link
                                                :href="$$route('ask-for-quote', {'askForQuote': askForQuote.id} )">
                                                {{ askForQuote.pfnumber }}
                                            </Link>
                                        </td>
                                        <td>{{ askForQuote.client_user.company }}</td>
                                        <td class="text-right" v-html="askForQuote.lot_qty"></td>
                                        <td class="text-right">{{ this.$date(askForQuote.delivery_date) }}</td>
                                        <td class="text-center">
                                            <svg-vue icon="checkmark-square" class="icon" v-if="askForQuote?.sketch_files.length > 0" />
                                            <svg-vue icon="checkmark-square-empty" class="icon" v-if="!askForQuote?.sketch_files.length > 0" />
                                            <svg-vue icon="checkmark-square" class="icon" v-if="askForQuote?.cad_files.length > 0" />
                                            <svg-vue icon="checkmark-square-empty" class="icon" v-if="!askForQuote?.cad_files.length > 0" />
                                        </td>
                                        <td class="text-right">{{ this.$date(askForQuote.created_at) }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </card-content>
                        </card>
                    </div>
                </div>
            </div>
        </div>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardTitle from '@partfactory/Shared/Card/CardTitle';

export default {
    name: 'Result',
    components: {CardTitle, CardContent, CardOverline, CardHeader, Card, AppAdminLayout},
    props: {
        askForQuotes: Object,
    },
};
</script>
